import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BuyContractService } from '../buy-contract.service';
import { AuthService } from '../../../auth/auth.service';

@Component({
  selector: 'app-buy-contract-form-dialog',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatProgressSpinnerModule,
    MatIconModule,
    MatButtonToggleModule,
    MatDatepickerModule,
    MatNativeDateModule,
  ],
  templateUrl: './buy-contract-form-dialog.html',
  styleUrl: './buy-contract-form-dialog.scss'
})
export class BuyContractFormDialog {
  form: FormGroup;
  loading = false;

  constructor(
    private fb: FormBuilder,
    private service: BuyContractService,
    private dialogRef: MatDialogRef<BuyContractFormDialog>,
    private snackBar: MatSnackBar,
    private authService: AuthService,
  ) {
    this.form = this.fb.group({
      name: [''],
      note: [''],
      target_coins: [null, [Validators.required, Validators.min(1)]],
      fee: [0, [Validators.min(0), Validators.max(10000000)]],
      target_type: ['received'],
    });
  }

  get isAdmin(): boolean {
    return this.authService.hasAnyRole('Admin', 'SuperAdmin');
  }

  onSubmit(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
    this.loading = true;
    const { target_coins, name, note, target_type, fee } = this.form.value;
    this.service.createBuyContract({
      name,
      note,
      target_coins: target_coins * 1000,
      target_type,
      fee: this.isAdmin ? fee : 0,
    }).subscribe({
      next: () => {
        this.snackBar.open('Buy contract created', 'Close', { duration: 4000 });
        this.dialogRef.close(true);
      },
      error: err => {
        const msg = err.error?.error || 'Error creating buy contract';
        this.snackBar.open(msg, 'Close', { duration: 5000 });
        this.loading = false;
      }
    });
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }

  getErrorMessage(field: string): string {
    const c = this.form.get(field);
    if (!c) return '';
    if (c.hasError('required')) return 'This field is required';
    if (c.hasError('min')) return `Minimum value is ${c.errors?.['min'].min}`;
    if (c.hasError('max')) return `Maximum value is ${c.errors?.['max'].max}`;
    return '';
  }
}
